import React from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import LocatorTypeSelect from './LocatorTypeSelect';

export default function EditLocatorModal({ row, form, loading, error, onClose, onSave }) {
  return (
    <Dialog open={Boolean(row)} onClose={onClose} maxWidth="sm" fullWidth>
      <Box component="form" onSubmit={onSave}>
        <DialogTitle>Edit locator</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '16px !important' }}
        >
          {row && (
            <Typography variant="body2" color="text.secondary">
              <b>{row.locator_name}</b> · {row.page} · {row.platform}
            </Typography>
          )}
          {error && <Alert severity="error">{error}</Alert>}
          <Controller
            name="locator_type"
            control={form.control}
            rules={{ required: 'Required' }}
            render={({ field, fieldState }) => (
              <LocatorTypeSelect error={fieldState.error} {...field} />
            )}
          />
          <TextField
            label="Locator value"
            size="small"
            multiline
            rows={3}
            {...form.register('locator_value', { required: 'Required' })}
            error={Boolean(form.formState.errors.locator_value)}
            helperText={form.formState.errors.locator_value?.message}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? <CircularProgress size={18} /> : 'Save'}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
